export default {"src":"/_next/static/media/powered_by_stripe.8c4e178c.svg","height":35,"width":325,"blurWidth":0,"blurHeight":0};